import { render, staticRenderFns } from "./SaldosHTCReportTable.vue?vue&type=template&id=5820fc3a&scoped=true"
import script from "./SaldosHTCReportTable.vue?vue&type=script&lang=js"
export * from "./SaldosHTCReportTable.vue?vue&type=script&lang=js"
import style0 from "./SaldosHTCReportTable.vue?vue&type=style&index=0&id=5820fc3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820fc3a",
  null
  
)

export default component.exports